import React from 'react';
import VisualizaHistoricoDacaSaidaOcorrencia from './visualizaHistoricoDacaSaidaOcorrencia/visualizaHistoricoDacaSaidaOcorrencia';
import VisualizaHistoricoDacaSaidaOutros from './visualizaHistoricoDacaSaidaOutros/visualizaHistoricoDacaSaidaOutros';

const ModalVisualizaHistoricoDacaSaida = (props) => {
	const {
		transacao,
		isDacaPermanente,
	} = props;

	return (
		<div>

			{/* visualizar transação de saída - ocorrência */}
			{transacao.ocorrencia !== null && (
				<React.Fragment>
					<VisualizaHistoricoDacaSaidaOcorrencia
						transacao={transacao}
						isDacaPermanente={isDacaPermanente}
					/>
				</React.Fragment>
			)}

			{/* visualizar transação de saída - outros */}
			{transacao.ocorrencia === null && (
				<React.Fragment>
					<VisualizaHistoricoDacaSaidaOutros
						transacao={transacao}
						isDacaPermanente={isDacaPermanente}
					/>
				</React.Fragment>
			)}

		</div>
	);
};

export default ModalVisualizaHistoricoDacaSaida;
